import { environment } from './environment';
import { httpClient } from '../http/http-client';

export class BaseApiService {
    protected http = httpClient;
    protected env = environment;

    protected getBasePath(): string {
        return `/api/${this.env.apiVersion}/`;
    }

    protected getAbsolutePath(targetUri: string): string {
        return this.getBasePath() + targetUri;
    }
}
